var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkKeywords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9551 17.4326C11.7753 17.6125 11.5618 17.7552 11.3268 17.8525C11.0919 17.9499 10.84 18 10.5857 18C10.3314 18 10.0795 17.9499 9.84455 17.8525C9.60959 17.7552 9.39611 17.6125 9.21631 17.4326L1.56726 9.78357C1.20413 9.42053 1.00008 8.92811 1 8.41463V2.9353C1 1.86789 1.86789 1 2.9362 1H8.41463C8.92731 1 9.42031 1.204 9.78357 1.56726L17.4326 9.21631C17.6125 9.39611 17.7552 9.60959 17.8525 9.84455C17.9499 10.0795 18 10.3314 18 10.5857C18 10.84 17.9499 11.0919 17.8525 11.3268C17.7552 11.5618 17.6125 11.7753 17.4326 11.9551L11.9551 17.4326Z",
    stroke: "#304EF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkKeywords);
export default __webpack_public_path__ + "static/media/link-keywords.a9ec85f51fa1aabf98285fb2534b78ff.svg";
export { ForwardRef as ReactComponent };